// function initCustomAddToCartHandler() {
//   const chestSelect = document.getElementById("measurement_a");
//   const sleeveSelect = document.getElementById("measurement_c");
//   const spineSelect = document.getElementById("measurement_b");
//   const atcButton = document.getElementById("add-to-cart-btn");

//   // Check if all elements exist before proceeding
//   if (!chestSelect || !sleeveSelect || !spineSelect || !atcButton) {
//     console.warn("Some required elements are missing.");
//     return;
//   }

//   // Disable ATC initially
//   atcButton.disabled = true;

//   // Enable button only if both required selects are chosen
//   const updateATCButton = () => {
//     atcButton.disabled = !(chestSelect.value && sleeveSelect.value);
//   };

//   chestSelect.addEventListener("change", updateATCButton);
//   sleeveSelect.addEventListener("change", updateATCButton);

//   // Add product to cart
//   const addToCart = async (variantId, properties = {}) => {
//     const payload = {
//       id: parseInt(variantId),
//       quantity: 1,
//       ...(Object.keys(properties).length && { properties }),
//     };

//     const response = await fetch("/cart/add.js", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(payload),
//     });

//     if (!response.ok) {
//       const errorText = await response.text();
//       console.error("Shopify error response:", errorText);
//       throw new Error("Failed to add variant to cart");
//     }

//     return response.json();
//   };

//   atcButton.addEventListener("click", async () => {
//     atcButton.classList.add("adding");
//     const chestVal = chestSelect.value;
//     const sleeveVal = sleeveSelect.value;
//     const spineVal = spineSelect.value;

//     if (!chestVal || !sleeveVal) {
//       alert("Please select both Chest (A) and Sleeve (C) measurements.");
//       atcButton.classList.remove("adding");
//       return;
//     }

//     try {
//       // Add chest variant with spine as property
//       await addToCart(chestVal, {
//         "Vest Measurement B : Spine": spineVal,
//       });

//       // Add sleeve variant without properties
//       await addToCart(sleeveVal);

//       // Redirect to cart
//       window.location.href = "/checkout";
//     } catch (err) {
//       console.error("Error adding to cart:", err);
//       alert("Something went wrong while adding items to the cart.");
//     } finally {
//       atcButton.classList.remove("adding");
//     }
//   });
// }

// function initFlickityHandler() {
//   const mainProductCarousel = document.querySelector(
//     ".main-product-media-carousel"
//   );
//   const thumbnailCarousel = document.querySelector(
//     ".product-thumbnail-media-carousel"
//   );

//   if (!mainProductCarousel || !thumbnailCarousel) {
//     console.warn("Flickity carousels are missing.");
//     return;
//   }

//   var flktyA = new Flickity(mainProductCarousel, {
//     contain: true,
//     pageDots: false,
//     prevNextButtons: false,
//     wrapAround: true,
//     groupCells: "100%",
//   });
//   var flktyB = new Flickity(thumbnailCarousel, {
//     asNavFor: ".main-product-media-carousel",
//     pageDots: false,
//     wrapAround: true,
//   });

//   flktyB.on("change", function (index) {
//     var allIframes = document.querySelectorAll(".product-media-inner iframe");
//     allIframes.forEach(function (iframe) {
//       var defaultSrc = iframe.getAttribute("data-src");
//       if (defaultSrc) {
//         iframe.src = defaultSrc;
//       }
//     });

//     var videoElement = document.querySelector(
//       '.product-thumbnail-inner[data-index="' + index + '"]'
//     );
//     if (videoElement) {
//       var videoSrc = videoElement.getAttribute("data-src");
//       if (videoSrc) {
//         var iframe = document.querySelector(
//           '.product-media-inner[data-index="' + index + '"] iframe'
//         );
//         if (iframe) {
//           iframe.src = videoSrc;
//         }
//       }
//     }
//   });

//   document
//     .querySelectorAll(
//       ".custom-featured-product-section .product-thumbnail-media-carousel .flickity-button"
//     )
//     .forEach((button) => {
//       button.addEventListener("click", function () {
//         setTimeout(() => {
//           const selected = document.querySelector(
//             ".product-thumbnail-media-carousel .product-thumbnail-inner.is-selected"
//           );
//           if (selected) {
//             selected.classList.add("is-nav-selected");
//           }
//         }, 100);
//       });
//     });
// }

// function sizeGuidancePopHandler() {
//   const popupOverlay = document.getElementById("popupOverlay");
//   const openPopupBtn = document.querySelector(".open-popup-btn");
//   const closeBtn = document.querySelector(".close-btn");

//   if (!popupOverlay || !openPopupBtn || !closeBtn) {
//     console.warn("Popup elements are missing.");
//     return;
//   }

//   openPopupBtn.addEventListener("click", togglePopup);

//   // Close the popup when clicking the close button or overlay area
//   popupOverlay.addEventListener("click", function (e) {
//     if (e.target === popupOverlay || e.target === closeBtn) {
//       closePopup();
//     }
//   });

//   function togglePopup() {
//     const isPopupOpen = popupOverlay.style.display === "flex";
//     popupOverlay.style.display = isPopupOpen ? "none" : "flex";
//     document.body.classList.toggle("overflow-hidden", !isPopupOpen);
//   }

//   function closePopup() {
//     popupOverlay.style.display = "none";
//     document.body.classList.remove("overflow-hidden");
//   }
// }

// function smoothScrollTo() {
//   const scrollButtons = document.querySelectorAll(".button_video_scroll");

//   if (scrollButtons.length === 0) {
//     console.warn("Scroll buttons not found.");
//     return;
//   }

//   scrollButtons.forEach((button) => {
//     button.addEventListener("click", function (event) {
//       event.preventDefault();
//       const targetId = this.getAttribute("href").replace("#", "");
//       const targetElement = document.getElementById(targetId);

//       if (targetElement) {
//         targetElement.scrollIntoView({ behavior: "smooth" });
//       }
//     });
//   });
// }

// function customAccordian() {
//   const accordions = document.querySelectorAll(".accordion_cstm");
//   accordions.forEach((accordion) => {
//     const toggle = accordion.querySelector(".accordion_text_cstm");
//     toggle.addEventListener("click", () => {
//       accordion.classList.toggle("active");
//     });
//   });
// }
// function initDefaultPriceListeners() {
//   const selectA = document.querySelector("#measurement_a");
//   const selectC = document.querySelector("#measurement_c");

//   if (selectA) {
//     selectA.addEventListener("change", () => {
//       console.log("Select A changed → updating price...");
//       initDefaultPriceFromSelects();
//     });
//   }

//   if (selectC) {
//     selectC.addEventListener("change", () => {
//       console.log("Select C changed → updating price...");
//       initDefaultPriceFromSelects();
//     });
//   }
// }
// function initDefaultPriceFromSelects() {
//   function parsePrice(priceStr) {
//     return parseFloat(priceStr.replace(/[^0-9.]/g, '')) || 0;
//   }

//   const selectA = document.querySelector('#measurement_a');
//   const selectC = document.querySelector('#measurement_c');
//   if (!selectA || !selectC) return;

//   const optionA = selectA.options[selectA.selectedIndex];
//   const optionC = selectC.options[selectC.selectedIndex];
//   if (!optionA || !optionC || !optionA.dataset.price || !optionC.dataset.price) return;

//   const priceA = parsePrice(optionA.dataset.price);
//   const comparePriceA = parsePrice(optionA.dataset.comparePrice);
//   const priceC = parsePrice(optionC.dataset.price);
//   const comparePriceC = parsePrice(optionC.dataset.comparePrice);

//   const totalPrice = priceA + priceC;
//   const totalComparePrice = comparePriceA + comparePriceC;

//   const currencyCode = window?.Shopify?.currency?.active || "USD";
//   const formattedTotalPrice = `$${totalPrice.toFixed(2)} ${currencyCode}`;
//   const formattedComparePrice = totalComparePrice > 0 ? `$${totalComparePrice.toFixed(2)} ${currencyCode}` : '';
//   const afterpayPrice = `$${(totalPrice / 4).toFixed(2)} ${currencyCode}`;

//   const regularPriceElement = document.querySelector('.product-price-element .regular-price-element');
//   const comparePriceElement = document.querySelector('.product-price-element .compare-at-price-element');
//   const afterpayElement = document.querySelector('.afterpay-instalments');
//   const discountElement = document.querySelector('.product-price-with-percentage-off-element .discount-element');

//   if (regularPriceElement) {
//     regularPriceElement.textContent = formattedTotalPrice;
//   }
//   if (comparePriceElement) {
//     comparePriceElement.textContent = formattedComparePrice;
//   }
//   if (afterpayElement) {
//     afterpayElement.textContent = afterpayPrice;
//   }
//   if (discountElement && totalComparePrice > totalPrice && totalComparePrice > 0) {
//     const percentOff = Math.round(((totalComparePrice - totalPrice) / totalComparePrice) * 100);
//     discountElement.textContent = `${percentOff}% OFF`;
//   } else if (discountElement) {
//     discountElement.textContent = '';
//   }
// }


// function initAllHandlers() {
//   initDefaultPriceFromSelects();
//   initDefaultPriceListeners();
//   initCustomAddToCartHandler();
//   initFlickityHandler();
//   sizeGuidancePopHandler();
//   smoothScrollTo();
//   customAccordian();
// }

// document.addEventListener("DOMContentLoaded", initAllHandlers);
// document.addEventListener("shopify:section:load", initAllHandlers);



 

function initCustomAddToCartHandler() {
  const chestSelect = document.getElementById("measurement_a");
  const sleeveSelect = document.getElementById("measurement_c");
  const spineSelect = document.getElementById("measurement_b");
  const atcButton = document.getElementById("add-to-cart-btn");

  // Check if all elements exist before proceeding
  if (!chestSelect || !sleeveSelect || !spineSelect || !atcButton) {
    console.warn("Some required elements are missing for two-product section.");
    return;
  }

  // Disable ATC initially
  atcButton.disabled = true;

  // Enable button only if both required selects are chosen
  const updateATCButton = () => {
    atcButton.disabled = !(chestSelect.value && sleeveSelect.value);
  };

  chestSelect.addEventListener("change", updateATCButton);
  sleeveSelect.addEventListener("change", updateATCButton);

  // Add product to cart
  const addToCart = async (variantId, properties = {}) => {
    const payload = {
      id: parseInt(variantId),
      quantity: 1,
      ...(Object.keys(properties).length && { properties }),
    };

    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Shopify error response:", errorText);
      throw new Error("Failed to add variant to cart");
    }

    return response.json();
  };

  atcButton.addEventListener("click", async () => {
    atcButton.classList.add("adding");
    const chestVal = chestSelect.value;
    const sleeveVal = sleeveSelect.value;
    const spineVal = spineSelect.value;

    if (!chestVal || !sleeveVal) {
      alert("Please select both Chest (A) and Sleeve (C) measurements.");
      atcButton.classList.remove("adding");
      return;
    }

    try {
      // Add chest variant with spine as property
      await addToCart(chestVal, {
        "Vest Measurement B : Spine": spineVal,
      });

      // Add sleeve variant without properties
      await addToCart(sleeveVal);

      // Redirect to cart
      window.location.href = "/checkout";
    } catch (err) {
      console.error("Error adding to cart:", err);
      alert("Something went wrong while adding items to the cart.");
    } finally {
      atcButton.classList.remove("adding");
    }
  });
}

/* ---------------- NEW FUNCTION for single-product section ---------------- */
function initSingleProductHandler() {
  const section = document.querySelector(".featured-product-with-single-option.custom-featured-product");
  if (!section) return;

  const selectA = section.querySelector("#measurement_a");
  const atcButton = section.querySelector("#add-to-cart-btn");

  if (!selectA || !atcButton) {
    console.warn("Single product elements missing.");
    return;
  }

  // disable ATC initially
  atcButton.disabled = true;

  // helper to parse price string
  function parsePrice(priceStr) {
    return parseFloat(priceStr.replace(/[^0-9.]/g, "")) || 0;
  }

  function updatePrice() {
    const option = selectA.options[selectA.selectedIndex];
    if (!option || !option.dataset.price) return;

    const price = parsePrice(option.dataset.price);
    const comparePrice = parsePrice(option.dataset.comparePrice);
    const currencyCode = window?.Shopify?.currency?.active || "USD";

    const regularPriceElement = section.querySelector(".product-price-element .regular-price-element");
    const comparePriceElement = section.querySelector(".product-price-element .compare-at-price-element");
    const afterpayElement = section.querySelector(".afterpay-instalments");
    const discountElement = section.querySelector(".product-price-with-percentage-off-element .discount-element");

    if (regularPriceElement) regularPriceElement.textContent = `$${price.toFixed(2)} ${currencyCode}`;
    if (comparePriceElement) comparePriceElement.textContent = comparePrice > 0 ? `$${comparePrice.toFixed(2)} ${currencyCode}` : "";
    if (afterpayElement) afterpayElement.textContent = `$${(price / 4).toFixed(2)} ${currencyCode}`;
    if (discountElement) {
      if (comparePrice > price && comparePrice > 0) {
        const percentOff = Math.round(((comparePrice - price) / comparePrice) * 100);
        discountElement.textContent = `${percentOff}% OFF`;
      } else {
        discountElement.textContent = "";
      }
    }
  }

  // enable button on selection
  selectA.addEventListener("change", () => {
    atcButton.disabled = !selectA.value;
    updatePrice();
  });

  // add to cart
  atcButton.addEventListener("click", async () => {
    const variantId = selectA.value;
    if (!variantId) {
      alert("Please select a size option first.");
      return;
    }

    atcButton.classList.add("adding");

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 }),
      });

      if (!response.ok) throw new Error(await response.text());

      // redirect to checkout (same as 2-product)
      window.location.href = "/checkout";
    } catch (err) {
      console.error("Error adding to cart:", err);
      alert("Something went wrong while adding item to the cart.");
    } finally {
      atcButton.classList.remove("adding");
    }
  });

  // run on load
  updatePrice();
}
/* ------------------------------------------------------------------------- */

function initFlickityHandler() {
  const mainProductCarousel = document.querySelector(
    ".main-product-media-carousel"
  );
  const thumbnailCarousel = document.querySelector(
    ".product-thumbnail-media-carousel"    
  ); 
  
  if (!mainProductCarousel || !thumbnailCarousel) {
    console.warn("Flickity carousels are missing.");
    return; 
  }

  var flktyA = new Flickity(mainProductCarousel, {
    contain: true,
    pageDots: false,
    prevNextButtons: false,
    wrapAround: true,
    groupCells: "100%",
    adaptiveHeight: true
  });
  var flktyB = new Flickity(thumbnailCarousel, {
    asNavFor: ".main-product-media-carousel",
    pageDots: false,
    wrapAround: true,
  });

  flktyB.on("change", function (index) {
    var allIframes = document.querySelectorAll(".product-media-inner iframe");
    allIframes.forEach(function (iframe) {
      var defaultSrc = iframe.getAttribute("data-src");
      if (defaultSrc) {
        iframe.src = defaultSrc;
      }
    });

    var videoElement = document.querySelector(
      '.product-thumbnail-inner[data-index="' + index + '"]'
    );
    if (videoElement) {
      var videoSrc = videoElement.getAttribute("data-src");
      if (videoSrc) {
        var iframe = document.querySelector(
          '.product-media-inner[data-index="' + index + '"] iframe'
        );
        if (iframe) {
          iframe.src = videoSrc;
        }
      }
    }
  });

  document
    .querySelectorAll(
      ".custom-featured-product-section .product-thumbnail-media-carousel .flickity-button"
    )
    .forEach((button) => {
      button.addEventListener("click", function () {
        setTimeout(() => {
          const selected = document.querySelector(
            ".product-thumbnail-media-carousel .product-thumbnail-inner.is-selected"
          );
          if (selected) {
            selected.classList.add("is-nav-selected");
          }
        }, 100);
      });
    });
}

function sizeGuidancePopHandler() {
  const popupOverlay = document.getElementById("popupOverlay");
  const openPopupBtn = document.querySelector(".open-popup-btn");
  const closeBtn = document.querySelector(".close-btn");

  if (!popupOverlay || !openPopupBtn || !closeBtn) {
    console.warn("Popup elements are missing.");
    return;
  }

  openPopupBtn.addEventListener("click", togglePopup);

  // Close the popup when clicking the close button or overlay area
  popupOverlay.addEventListener("click", function (e) {
    if (e.target === popupOverlay || e.target === closeBtn) {
      closePopup();
    }
  });

  function togglePopup() {
    const isPopupOpen = popupOverlay.style.display === "flex";
    popupOverlay.style.display = isPopupOpen ? "none" : "flex";
    document.body.classList.toggle("overflow-hidden", !isPopupOpen);
  }

  function closePopup() {
    popupOverlay.style.display = "none";
    document.body.classList.remove("overflow-hidden");
  }
}

function smoothScrollTo() {
  const scrollButtons = document.querySelectorAll(".button_video_scroll");

  if (scrollButtons.length === 0) {
    console.warn("Scroll buttons not found.");
    return;
  }

  scrollButtons.forEach((button) => {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      const targetId = this.getAttribute("href").replace("#", "");
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" });
      }
    });
  });
}

function customAccordian() {
  const accordions = document.querySelectorAll(".accordion_cstm");
  accordions.forEach((accordion) => {
    const toggle = accordion.querySelector(".accordion_text_cstm");
    toggle.addEventListener("click", () => {
      accordion.classList.toggle("active");
    });
  });
}

function initDefaultPriceListeners() {
  const selectA = document.querySelector("#measurement_a");
  const selectC = document.querySelector("#measurement_c");

  if (selectA) {
    selectA.addEventListener("change", () => {
      console.log("Select A changed → updating price...");
      initDefaultPriceFromSelects();
    });
  }

  if (selectC) {
    selectC.addEventListener("change", () => {
      console.log("Select C changed → updating price...");
      initDefaultPriceFromSelects();
    });
  }
}

function initDefaultPriceFromSelects() {
  function parsePrice(priceStr) {
    return parseFloat(priceStr.replace(/[^0-9.]/g, '')) || 0;
  }

  const selectA = document.querySelector('#measurement_a');
  const selectC = document.querySelector('#measurement_c');
  if (!selectA || !selectC) return;

  const optionA = selectA.options[selectA.selectedIndex];
  const optionC = selectC.options[selectC.selectedIndex];
  if (!optionA || !optionC || !optionA.dataset.price || !optionC.dataset.price) return;

  const priceA = parsePrice(optionA.dataset.price);
  const comparePriceA = parsePrice(optionA.dataset.comparePrice);
  const priceC = parsePrice(optionC.dataset.price);
  const comparePriceC = parsePrice(optionC.dataset.comparePrice);

  const totalPrice = priceA + priceC;
  const totalComparePrice = comparePriceA + comparePriceC;

  const currencyCode = window?.Shopify?.currency?.active || "USD";
  const symbol = new Intl.NumberFormat('en', {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(0).replace(/[0-9.,\s]/g, '');
  console.log(symbol);
  // const formattedTotalPrice = `${totalPrice.toFixed(2)} ${currencyCode}`;
  // const formattedComparePrice = totalComparePrice > 0 ? `${totalComparePrice.toFixed(2)} ${currencyCode}` : '';
  // const afterpayPrice = `${(totalPrice / 4).toFixed(2)} ${currencyCode}`;

  const formattedTotalPrice = `${symbol}${totalPrice.toFixed(2)}`;
  const formattedComparePrice = totalComparePrice > 0 ? `${symbol}${totalComparePrice.toFixed(2)}` : '';
  const afterpayPrice = `${symbol}${(totalPrice / 4).toFixed(2)}`;


  const regularPriceElement = document.querySelector('.product-price-element .regular-price-element');
  const comparePriceElement = document.querySelector('.product-price-element .compare-at-price-element');
  const afterpayElement = document.querySelector('.afterpay-instalments');
  const discountElement = document.querySelector('.product-price-with-percentage-off-element .discount-element');

  if (regularPriceElement) {
    regularPriceElement.textContent = formattedTotalPrice;
  }
  if (comparePriceElement) {
    comparePriceElement.textContent = formattedComparePrice;
  }
  if (afterpayElement) {
    afterpayElement.textContent = afterpayPrice;
  }
  if (discountElement && totalComparePrice > totalPrice && totalComparePrice > 0) {
    const percentOff = Math.round(((totalComparePrice - totalPrice) / totalComparePrice) * 100);
    discountElement.textContent = `${percentOff}% OFF`;
  } else if (discountElement) {
    discountElement.textContent = '';
  }
}

function initAllHandlers() {
  initDefaultPriceFromSelects();
  initDefaultPriceListeners();
  initCustomAddToCartHandler();   // two-product section
  initSingleProductHandler();     // single-product section
  initFlickityHandler();
  sizeGuidancePopHandler();
  smoothScrollTo();
  customAccordian();
}

document.addEventListener("DOMContentLoaded", initAllHandlers);
document.addEventListener("shopify:section:load", initAllHandlers);
